import { Search, Filter } from 'lucide-react';
import Button from '@components/common/Button';

const FilterBar = ({ 
  searchValue, 
  onSearchChange, 
  filters = [], 
  activeFilter, 
  onFilterChange,
  placeholder = "Search...",
  children 
}) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 items-start md:items-center">
      <div className="flex-1 w-full">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-primary-400" />
          <input
            type="text"
            placeholder={placeholder}
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg bg-white text-primary-900 focus:outline-none focus:ring-2 focus:ring-primary-400"
          />
        </div>
      </div>
      
      {filters.length > 0 && (
        <div className="flex gap-2 flex-wrap">
          {filters.map((filter) => (
            <Button
              key={filter.value}
              variant={activeFilter === filter.value ? 'primary' : 'outline'}
              size="sm"
              onClick={() => onFilterChange(filter.value)}
              className="capitalize"
            >
              {filter.label}
            </Button>
          ))}
        </div>
      )}
      
      {children}
    </div>
  );
};

export default FilterBar;
